import { useEffect, useRef, memo } from "react";
import { resolveTradingViewSymbol } from "@/helpers/tickerHelpers";

type ChartProps = {
  symbols: string | string[][];
};

const Chart: React.FC<ChartProps> = ({ symbols }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const formattedSymbols: string[][] = (
    Array.isArray(symbols)
      ? Array.isArray(symbols[0] as unknown)
        ? (symbols as string[][])
        : [symbols as unknown as string[]]
      : [[symbols]]
  ).map((entry) => [resolveTradingViewSymbol(entry[0]), ...entry.slice(1)]);

  useEffect(() => {
    if (!containerRef.current) return;

    containerRef.current.innerHTML = "";

    const script = document.createElement("script") as HTMLScriptElement;
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.async = true;

    script.innerHTML = JSON.stringify({
      symbols: formattedSymbols,
      chartType: "area",
      width: "100%",
      height: 300,
      autosize: true,
      locale: "en",
      colorTheme: "light",
      showVolume: false,
      showMA: false,
      hideDateRanges: false,
      hideMarketStatus: true,
      hideSymbolLogo: false,
      scalePosition: "right",
      scaleMode: "Normal",
      valuesTracking: "1",
      changeMode: "price-and-percent",
      lineWidth: 2,
      lineType: 0,
      dateRanges: ["1d|1", "1m|1D", "3m|60", "12m|1D", "60m|1W", "all|1M"],
    });

    containerRef.current.appendChild(script);
  }, [formattedSymbols]);

  return <div ref={containerRef} style={{ width: "100%" }} />;
};

export default memo(Chart);
